import ECharts from "vue-echarts";
import {use} from "echarts/core";
import {SVGRenderer} from "echarts/renderers";
import {LegacyGridContainLabel} from "echarts/features";
import {BarChart, PieChart, LineChart, RadarChart, MapChart} from "echarts/charts";
import {
    GridComponent,
    TooltipComponent,
    LegendComponent,
    ToolboxComponent,
    DatasetComponent,
    VisualMapComponent,
    TitleComponent,
    DataZoomSliderComponent,
    DataZoomInsideComponent,
    DataZoomComponent
} from "echarts/components";
use([
    BarChart,
    PieChart,
    LineChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    ToolboxComponent,
    DatasetComponent,
    RadarChart,
    VisualMapComponent,
    MapChart,
    TitleComponent,
    DataZoomSliderComponent,
    DataZoomInsideComponent,
    DataZoomComponent,
    LegacyGridContainLabel,
    SVGRenderer
]);

export default ECharts;
